export const experience = [
    {
        from: 'Apr-2025',
        to: 'Present',
        title: 'Full Stack Developer',
        company: 'IBM',
        details: [
            'Designed and developed scalable full-stack applications using modern frameworks and technologies.',
            'Implemented RESTful APIs and integrated third-party services to enhance application functionality.',
            'Optimized application performance and ensured cross-browser compatibility.',
            'Collaborated with cross-functional teams to deliver high-quality software solutions on time.',
            'Participated in code reviews, mentoring junior developers, and promoting best practices in software development.',
            'Utilized Agile methodologies to manage project timelines and deliverables effectively.'
        ]
    },
    {
        from: 'May-2024',
        to: 'Mar-2025',
        title: 'Analyst Programmer',
        company: 'Sik Sik Yuen',
        details: [
            'Assist in analyzing user requirements to design tailored software solutions.',
            'Contribute to system analysis and recommend enhancements to improve functionality and efficiency.',
            'Collaborate closely with team members to implement well-structured solutions that meet business needs.',
        ]
    },
    {
        from: 'Jun-2023',
        to: 'Feb-2024',
        title: 'Intern Programmer',
        company: 'Sik Sik Yuen',
        details: [
            'Full time internship, working Mon - Fri, 9-6',
            'Developed and modified software applications based on detailed specifications.',
            'Worked closely with users and stakeholders to gather requirements and refine project deliverables.',
        ]
    },
    {
        from: 'Apr-2019',
        to: 'May-2020',
        title: 'Software Support Officer ',
        company: 'InnoviTech Solutions',
        details: [
            'Provided technical assistance and support to users experiencing software issues.',
            'Troubleshot software problems and identified root causes.',
            'Guided users on software functionalities and features.',
        ]
    }
]